export const OLD_ORDER_STATUS_ID = {
  PAYMENT_PROCESS: 1,
  DELIVERY_PROCESS: 2,
  DELIVERED: 3,
  CANCELLED: 4,
  CONFIRMED: 5,
  ACTIVE: 6,
  INACTIVE: 7
};
export type TOldOrderStatusId = typeof OLD_ORDER_STATUS_ID[keyof typeof OLD_ORDER_STATUS_ID];

export const LOGISTIC_SERVICE_STATUS_ID = {
  TO_CONFIRMED: 1,
  CONFIRMED: 2,
  ACTIVE: 3,
  DELIVERED: 4,
  CANCELLED: 5,
  IN_PROCESS: 6
};
export type TLogisticServiceStatusId = typeof LOGISTIC_SERVICE_STATUS_ID[keyof typeof LOGISTIC_SERVICE_STATUS_ID];


export const LOGISTIC_SERVICE_STATUS_NAME = {
  TO_CONFIRMED: 'por confirmar',
  CONFIRMED: 'confirmado',
  ACTIVE: 'activo',
  DELIVERED: 'entregado',
  CANCELLED: 'cancelado',
  IN_PROCESS: 'en proceso',
  DELAYED: 'atrasado'
} as const;
export type TLogisticServiceStatusName = typeof LOGISTIC_SERVICE_STATUS_NAME[keyof typeof LOGISTIC_SERVICE_STATUS_NAME];

export interface IShipmentDestinationInfo {
  destinationPlace: string;
  receiverName: string;
  destinationCountryName: string;
};

export interface IEventResponsibleInfo {
  fullNameOrEmail: string;
};

export interface IRelevantInfo {
  responsible?: IEventResponsibleInfo;
  destination?: IShipmentDestinationInfo;
};

export interface IEventType {
  id?: number;
  uuid?: string;
  name?: string;
  description?: string | null;
}

export interface IOrderHistoryEvent {
  id?: number;
  orderId?: number;
  statusId?: number;
  shipmentGroupId?: number | null;
  saleId?: number | null;
  shipmentId?: null;
  eventTypeId?: number;
  details?: string | null;
  userId?: number | null;
  validUntil?: string | null;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  eventType?: IEventType;
  relevantInfo?: IRelevantInfo;
}

export interface IOrderHistory {
  statusId: TOldOrderStatusId;
  name: string;
  nameStringId: string;
  events: IOrderHistoryEvent[];
}

export interface ILogisticServiceHistoryEvent {
  id?: number;
  serviceId?: number;
  statusId?: number;
  eventTypeId?: number;
  details?: string | null;
  userId?: number | null;
  createdAt?: string;
  validUntil?: string | null;
  updatedAt?: string;
  deletedAt?: string | null;
  eventType?: IEventType;
  relevantInfo?: IRelevantInfo;
}

export interface ILogisticServiceHistory {
  statusId: TLogisticServiceStatusId;
  name: string;
  nameStringId: string;
  events: ILogisticServiceHistoryEvent[];
}
